;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('shareUsers', shareUsers)

  /* @ngInject */
  function shareUsers () {
    return {
      restrict: 'E',
      scope: {
        art: '<',
        selectedUsers: '=',
        invitedUsers: '='
      },
      templateUrl: '/arts/directives/share-users/share-users-directive.html?$$REVISION$$',
      controller: 'ShareUsersController'
    }
  }
})()
